import React from 'react';
import { PlusIcon } from '../../appearence/icons/plus_icon';
import { useTranslation } from 'react-i18next';
import { POPUP_KEY_ADD_INGREDIENT_TO_RECIPE } from '../../constant';
import { popupOpenService } from '../../shared/popupOpenService';
import { Button } from '@chapche/ui';

const AddNewIngredientButton = () => {
    const { i18n } = useTranslation();
    const openPopup = () => {
        popupOpenService.callToOpen(POPUP_KEY_ADD_INGREDIENT_TO_RECIPE);
    };

    return (
        <Button variant="outline" className="recipe__add-product" onClick={openPopup}>
            {i18n.t('app.page.recipe.addProduct')}
            <PlusIcon nameOfClass="recipe__add-product-icon" handleClick={() => null}/>
        </Button>
    );
};

export default AddNewIngredientButton;
